var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTealInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00087 0.972656C4.24262 0.972656 1.19531 4.01997 1.19531 7.77821C1.19531 11.5365 4.24262 14.5838 8.00087 14.5838C11.7591 14.5838 14.8064 11.5365 14.8064 7.77821C14.8064 4.01997 11.7591 0.972656 8.00087 0.972656ZM8.48698 11.0595C8.48698 11.1263 8.43229 11.181 8.36545 11.181H7.63628C7.56944 11.181 7.51476 11.1263 7.51476 11.0595V6.92752C7.51476 6.86068 7.56944 6.80599 7.63628 6.80599H8.36545C8.43229 6.80599 8.48698 6.86068 8.48698 6.92752V11.0595ZM8.00087 5.83377C7.81006 5.82987 7.62838 5.75134 7.49481 5.61502C7.36124 5.4787 7.28643 5.29545 7.28643 5.1046C7.28643 4.91375 7.36124 4.73051 7.49481 4.59418C7.62838 4.45786 7.81006 4.37933 8.00087 4.37543C8.19168 4.37933 8.37336 4.45786 8.50693 4.59418C8.64049 4.73051 8.7153 4.91375 8.7153 5.1046C8.7153 5.29545 8.64049 5.4787 8.50693 5.61502C8.37336 5.75134 8.19168 5.82987 8.00087 5.83377Z",
    fill: "#128370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTealInfoIcon);
export default __webpack_public_path__ + "static/media/teal-info-icon.0457153685b2d7162acb6314722360eb.svg";
export { ForwardRef as ReactComponent };